module.exports = __webpack_public_path__ + "static/media/motorboat_active_ic.b1e34001.svg";